import LegalPage from '@/pages/legal/components/LegalPage';
import { mentionsLegalesContent } from '@/mocks/mentionsLegalesContent';

export default function MentionsLegales() {
  return <LegalPage content={mentionsLegalesContent} />;
}